import {
  Component,
  Prop,
  Element,
  Event,
  EventEmitter,
  h,
  Listen,
  Host,
} from "@stencil/core";

@Component({
  tag: "scs-autocomplete-option",
  styleUrls: ["autocomplete-option.scss"],
  shadow: true,
})
export class AutocompleteOption {
  private autocompleteEl!: HTMLScsAutocompleteElement;

  @Element() host!: HTMLScsAutocompleteOptionElement;

  /** @internal defines if current option is displayed as focused */
  @Prop() hasFocus: boolean = false;

  @Event()
  autocompleteOptionLoaded!: EventEmitter<HTMLScsAutocompleteOptionElement>;
  @Event()
  autocompleteOptionSelected!: EventEmitter<HTMLScsAutocompleteOptionElement>;

  @Listen("click")
  clickHandler() {
    this.autocompleteOptionSelected.emit(this.host);
  }

  @Listen("keydown", { target: "window" })
  keydownHandler(ev: KeyboardEvent) {
    if (ev.key === "Enter" && this.hasFocus) {
      this.autocompleteOptionSelected.emit(this.host);
    }
  }

  componentWillLoad() {
    this.autocompleteEl = this.host.closest(
      "scs-autocomplete",
    ) as HTMLScsAutocompleteElement;
  }

  componentDidLoad() {
    this.autocompleteOptionLoaded.emit(this.host);
  }

  disconnectedCallback() {
    this.autocompleteEl.autocompleteOptionRemoved();
  }

  render() {
    return (
      <Host
        role="option"
        aria-selected={this.hasFocus}
        class={{
          "autocomoplete-option": true,
          focus: this.hasFocus,
        }}
      >
        <div class="wrapper">
          <slot />
        </div>
      </Host>
    );
  }
}
